function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.0918 3.72524C17.591 5.18023 18.5602 6.82527 18.9764 7.61506C18.0574 9.09141 15.0183 13.2134 9.99936 13.2134C4.98046 13.2134 1.94137 9.09141 1.02234 7.61506C1.43852 6.82527 2.40773 5.18024 3.90692 3.72524C5.44977 2.22787 7.47956 1 9.99936 1C12.5192 1 14.549 2.22787 16.0918 3.72524ZM19.9008 7.22478C20.0411 7.4952 20.0301 7.80977 19.871 8.06959C18.9871 9.51268 15.6725 14.2134 9.99936 14.2134C4.32625 14.2134 1.01163 9.51268 0.127728 8.06959C-0.0314148 7.80977 -0.0424226 7.4952 0.0979488 7.22478C0.935048 5.61211 4.26044 0 9.99936 0C15.7383 0 19.0637 5.61211 19.9008 7.22478ZM10.0008 11.5477C12.5394 11.5477 14.5973 9.55907 14.5973 7.106C14.5973 4.65293 12.5394 2.66432 10.0008 2.66432C7.46228 2.66432 5.40436 4.65293 5.40436 7.106C5.40436 9.55907 7.46228 11.5477 10.0008 11.5477Z",
  fill: "#767B87"
});

const SvgViewSolid = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgViewSolid, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/view_solid.abb877a1.svg";
export { ForwardRef as ReactComponent };